module.exports = __webpack_public_path__ + "static/technology-parallax-0829b37515c6e0c95eee4b6e785c4ddc.jpg";